import React, { useEffect, useMemo, useRef, useState } from "react";
import { Card } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { shallowEqual, useSelector } from "react-redux";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import SuccessModal from "../../Modal/SuccessModal";
import { ClearingAccountReportFilter } from "./clearing-account-report-filter/ClearingAccountReportFilter";
import { ClearingAccountReportTable } from "./clearing-account-report-table/ClearingAccountReportTable";
import { useClearingAccountReportUIContext } from "./ClearingAccountReportUIContext";

export function ClearingAccountReportCard({}) {
  const [isSuccessModalShow, setSuccessModal] = useState(false);
  const clearingAccountReportUIContext = useClearingAccountReportUIContext();
  const clearingAccountReportUIProps = useMemo(() => {
    return {
      handleExportButton: clearingAccountReportUIContext.handleExportButton
    };
  }, [clearingAccountReportUIContext]);

  const myRef = useRef(null);
  const onhandleReset = () => {
    myRef.current.click();
  };

  const { currentState } = useSelector(
    (state) => ({ currentState: state.clearingAccountReport }),
    shallowEqual
  );

  const { actionsLoading, xlsFilename } = currentState || {};

  useEffect(() => {
    if (xlsFilename) {
      handleSuccessModalShow();
    }
  }, [xlsFilename]);

  const handleSuccessModalShow = () => {
    setSuccessModal(true);
  };

  const handleSuccessModalHide = () => {
    setSuccessModal(false);
  };

  return (
    <>
      <Card className="card-custom card-stretch make-payment-wrapper">
        <Card.Header className="align-items-center border-bottom mt-4  d-lg-flex">
          <h3 className="card-title align-items-start flex-column">
            <span className="font-weight-bold text-dark">
              Clearing Account Report
            </span>
          </h3>
          <button
            type="button"
            className="btn btn-secondary btn-lg"
            // disabled={false}
            onClick={onhandleReset}
          >
            Reset
          </button>
          <button
            className="btn btn-light-primary btn-lg"
            disabled={false}
            onClick={() => {
              clearingAccountReportUIProps.handleExportButton();
            }}
          >
            Export
            {actionsLoading && (
              <span className="ml-1 mr-3 spinner spinner-white"></span>
            )}
          </button>
        </Card.Header>
        <Card.Body>
          <ClearingAccountReportFilter myRef={myRef} />
          <ClearingAccountReportTable />
        </Card.Body>
      </Card>
      {isSuccessModalShow && (
        <SuccessModal
          message={
            "Your export has been successfully scheduled. Download the export file from mail - 'admin@payxtreme.com'"
          }
          isConfirmModal={isSuccessModalShow}
          handleConfirmHide={handleSuccessModalHide}
          successIcon={
            <div className="success-icon-wrapper text-center">
              <span className="svg-icon menu-icon svg-icon-white svg-icon-4x mr-0">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Navigation/Check.svg")}
                />
              </span>
            </div>
          }
        />
      )}
    </>
  );
}
